export type {
  CompositeDef,
  CompositeState,
  CompositeTemplateId,
  FlameSlotDef,
  FlickerConfigDef,
  FlickerProfile,
  LightEmitterSlotsDef,
  LightEmitterState,
  LightSlotDef,
  LightSlotType,
  MeshSlotDef,
  SceneCompositeInstance,
} from './types';
export { CompositeInstance } from './CompositeInstance';
export {
  getTemplate,
  registerTemplate,
  requireTemplate,
  resolveState,
  type StateFieldSchema,
  type StateSchema,
  type Template,
} from './Template';
export { resolveSocket } from './socketResolver';
export { instantiateComposite } from './instantiate';
export { manifestDefToEngineDef, manifestPlacementToEngine } from './manifest';
export {
  composeFlameWorldPosition,
  composeMeshWorldTRS,
  composeLightWorldPosition,
  effectiveLightLocal,
} from './transform';
export { buildLightFromSlot } from './lightFactory';
export { buildFlameFromSlot } from './flameFactory';
// Side-effect import — registers the built-in template at module load.
import './templates/lightEmitter';
